export default {
  changed_by: 'Ændret af',
  changed_at: 'Ændrings tidspunkt',
  class_room: 'Klasse eller stue',
  year: 'Årgang',
  institution: 'Institution',
  yes: 'Ja',
  no: 'Nej',
  number_of_selected: '{number} ud af {total} valgt',
  not: 'ikke',
  locked: 'låst',
  title: 'Titel',
  category: 'Kategori',
  description: 'Beskrivelse',
  child: 'Barn',
  edited: 'Redigeret',
  children_metadata: '{name} ({metadata})',
  children_summary:
    '@:label.children_metadata | @:label.children_metadata <b>+ @:label.other</b> | @:label.children_metadata <b>+ @:label.others</b>',
  and: 'og',
  other: '1 anden',
  others: '{count} andre',
  fold_out: 'Fold ud',
  share: 'Del',
  export: 'Eksporter',
  day: 'dag',
  daily: 'dagligt',
  month: 'i måneden',
  occur: 'Forekommer',
  every: 'hver',
  end_after: 'og slutter efter {total} gentagelser',
  and_end: 'og slutter efter',
  number_of_weeks: '1 uge | {count} uger',
  number_of_months: '1 måned | {count} måneder',
  deleted: 'Slettet',
  all: 'Alle',
  unread: 'Ulæste',
  filter_locked: 'Låste',
  search_by_child: 'Søg efter barn',
  search_by_category: 'Søg efter kategori',
  employee_profile: 'Medarbejderprofiler',
  week_number: 'Uge {number}',
  active: 'Aktiv',
  deactivated: 'Deaktiveret',
  unfold: 'Fold alle ud',
  number_of_comments: '1 kommentar | {count} kommentarer',
  number_of_unread: '1 ulæst | {count} ulæste',
  created_by: 'Oprettet af {name}',
  co_hosted_by: 'Medarrangeret af {name}',
  invitees: 'Inviterede',
  number_of_days: '1 dag | {count} dage',
  number_of_hours: '1 time | {count} timer',
  number_of_minutes: '1 minut | {count} minutter',
  specify_number_of_adults: 'Angiv antal voksne',
  specify_number_of_children: 'Angiv antal børn',
  warning: 'Advarsel',
  regarding: 'Vedrører',
  adjust_expired_date: 'Justér synlig til {option}',
  chosen_expired_date: 'Synlig til dato {expireDate}',
  sort_by_created_date: 'Oprettelsesdato',
  sort_by_album_name: 'Navn',
  sort_by_newest_media: 'Nyeste medier',
  sort_first: 'først',
  sort_last: 'sidst',
  sort_a_z: 'a til z',
  sort_z_a: 'z til a',
  sort_asc: 'stigende',
  sort_dsc: 'faldende',
  select_more: 'Vælg flere',
  select_all: 'Vælg alle',
  total_selected: '{count} valgt',
  member_of: 'Medlemmer af {name}',
  the: 'det | de',
  new: 'Ny',
  aula_info: 'Aulainfo',
  aula_info_help: 'Få hjælp til Aula',
  aula_info_help_short: 'Hjælp til Aula',
  operating_status_info: 'Informationer om driftstatus',
  note: 'Bemærk',
};
